import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInformationCircleMini = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 2.75C5.10051 2.75 2.75 5.10051 2.75 8C2.75 10.8995 5.10051 13.25 8 13.25C10.8995 13.25 13.25 10.8995 13.25 8C13.25 5.10051 10.8995 2.75 8 2.75ZM1.25 8C1.25 4.27208 4.27208 1.25 8 1.25C11.7279 1.25 14.75 4.27208 14.75 8C14.75 11.7279 11.7279 14.75 8 14.75C4.27208 14.75 1.25 11.7279 1.25 8ZM7.25 5.5C7.25 5.08579 7.58579 4.75 8 4.75H8.005C8.41921 4.75 8.755 5.08579 8.755 5.5V5.505C8.755 5.91921 8.41921 6.255 8.005 6.255H8C7.58579 6.255 7.25 5.91921 7.25 5.505V5.5ZM7.41559 8.24532C7.17204 8.21751 6.94698 8.07101 6.82918 7.83541C6.64394 7.46493 6.79411 7.01442 7.16459 6.82918L7.19225 6.81535C8.14745 6.33775 9.22296 7.2005 8.96394 8.23655L8.58441 9.75468C8.82795 9.78249 9.05302 9.92899 9.17082 10.1646C9.35606 10.5351 9.2059 10.9856 8.83542 11.1708L8.80776 11.1846C7.85256 11.6622 6.77704 10.7995 7.03606 9.76345L7.41559 8.24532Z",
		fill: "currentcolor"
	})]
});
export default SvgInformationCircleMini;
